import React from 'react';
import { cn } from '../../lib/utils';
import WorkflowEditorPanelShell from './WorkflowEditorPanelShell';

/** Shell props passed from workflow builder pages via getPanelShellProps(). */
export const WORKFLOW_EDITOR_SHELL_PROPS = [
  'width',
  'overlayMode',
  'onOverlayDismiss',
  'activePanelType',
  'chromeHeight',
];

export function pickWorkflowEditorShellProps(props, activePanelType) {
  return {
    width: props.width,
    overlayMode: props.overlayMode,
    onOverlayDismiss: props.onOverlayDismiss,
    activePanelType: props.activePanelType ?? activePanelType,
    chromeHeight: props.chromeHeight,
  };
}

/**
 * Embedded right-panel wrapper for workflow step/config editors.
 * Replaces viewport-fixed drawers inside WorkflowBuilderBodyLayout editor slot.
 */
const WorkflowStepEditorShell = ({
  isOpen = true,
  width,
  overlayMode = false,
  onOverlayDismiss,
  activePanelType = 'step-editor',
  chromeHeight,
  className,
  testId,
  children,
}) => (
  <WorkflowEditorPanelShell
    isOpen={isOpen}
    width={width ?? 480}
    overlayMode={overlayMode}
    onOverlayDismiss={onOverlayDismiss}
    activePanelType={activePanelType}
    chromeHeight={chromeHeight}
    className={className}
    testId={testId}
  >
    <div className="flex h-full min-h-0 flex-col" data-workflow-editor-ignore-pan>
      {children}
    </div>
  </WorkflowEditorPanelShell>
);

export default WorkflowStepEditorShell;
